<template>
  <section>
    <div>
      <coozzy-page-title
        :title="$tc('message.processHandoverTemplate.title')" />
    </div>
    <div class="row">
      <div class="col">
        <div
          v-if="loading"
          class="text-center">
          <coozzy-spinner />
        </div>
        <div
          v-if="activeTab === 0"
          class="row">
          <div class="col-3">
            <label>{{ $t('message.processHandoverTemplate.name') }}*</label>
            <coozzy-form-input
              id="handoverName"
              ref="handoverName"
              v-model="handover.name"
              :state="$v.handover.name.$dirty && $v.handover.name.$error ? false : null"
              type="text" />
          </div>
        </div>
        <div
          v-if="activeTab === 0"
          class="row">
          <div class="col-3 mt-2">
            <coozzy-multiselect
              id="sanitaries"
              v-model="selectedProperties"
              :options="availablePropertyOptions"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :preselect-first="false"
              :taggable="false"
              :custom-label="customLabelProperty"
              label="id"
              track-by="id">
              {{ $t('message.processHandoverTemplate.properties') }}
            </coozzy-multiselect>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <form-wizard
              id="wizard"
              ref="wizard-form"
              :hide-buttons="loading"
              title=""
              subtitle=""
              step-size="xs"
              color="rgb(0, 68, 95)"
              @on-change="handleTabChange">
              <template #title>
                <span />
              </template>
              <tab-content
                :key="'tabRoom'"
                :title="$t(`message.processHandover.rooms.title`)">
                <div
                  v-if="loading"
                  class="text-center">
                  <coozzy-spinner />
                </div>
                <div
                  v-else
                  class="row">
                  <handover-rooms-step
                    v-if="loading === false && activeTab === 0"
                    :object="null"
                    :source="'template'"
                    :self-rooms="handover.rooms.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)"
                    :pre-selected-rooms="preSelectedRooms.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)"
                    @selected-rooms="storeSelectedRooms"
                    @deleted-rooms="storeDeletedRooms" />
                </div>
              </tab-content>
              <tab-content
                :key="'tabDevice'"
                :title="$t(`message.processHandover.devices.title`)">
                <div
                  v-if="loading"
                  class="text-center">
                  <coozzy-spinner />
                </div>
                <handover-devices-step
                  v-else-if="activeTab === 1"
                  :object="null"
                  :source="'template'"
                  :devices="listDevices.filter(x => x.referenceId === 'template' && !isDeletedDeviceId(x.id))"
                  :pre-selected-rooms="preSelectedRooms.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)"
                  :handover-deleted-device-ids="deletedDevices"
                  @selected-rooms="storeSelectedRooms"
                  @deleted-devices="storeDeletedDevices"
                  @devices-without-rooms="storeDevicesWithoutRooms" />
              </tab-content>
              <tab-content
                :key="'tabKeys'"
                :title="$t(`message.processHandover.keys.title`)">
                <div
                  v-if="loading"
                  class="text-center">
                  <coozzy-spinner />
                </div>
                <handover-keys-step
                  v-else-if="activeTab === 2"
                  :object="null"
                  :source="'template'"
                  :init-keys="initKeys.filter(k => !isDeletedDeviceId(k.id))"
                  :pre-selected-rooms="preSelectedRooms.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)"
                  :handover-deleted-device-ids="deletedDevices"
                  @selected-rooms="storeSelectedRooms"
                  @deleted-keys="storeDeletedDevices"
                  @update-keys="storeDevicesWithoutRooms" />
              </tab-content>
              <template
                #footer="props">
                <template v-if="!loading">
                  <div class="wizard-footer-left">
                    <wizard-button
                      v-if="props.activeTabIndex === 0"
                      :style="props.fillButtonStyle"
                      @click.native="$router.back()">
                      {{ $t('message.generic.cancel') }}
                    </wizard-button>
                    <wizard-button
                      v-else
                      :style="props.fillButtonStyle"
                      @click.native="backClicked(props)">
                      {{ $t('message.generic.back') }}
                    </wizard-button>
                  </div>
                  <div class="wizard-footer-right">
                    <wizard-button
                      v-if="!props.isLastStep && !loading"
                      class="wizard-footer-right"
                      :style="props.fillButtonStyle"
                      @click.native="nextStep(props)">
                      {{ $t('message.generic.save_next') }}
                    </wizard-button>
                    <wizard-button
                      v-else-if="props.isLastStep"
                      class="wizard-footer-right"
                      :style="props.fillButtonStyle"
                      @click.native="nextStep(props)">
                      <template>
                        {{ $t('message.generic.form.save') }}
                      </template>
                    </wizard-button>
                  </div>
                </template>
              </template>
            </form-wizard>
          </div>
        </div>
      </div>
      <!--    <b-modal-->
      <!--      id="confirmationModal"-->
      <!--      ref="confirmationModal"-->
      <!--      no-close-on-backdrop-->
      <!--      :title="$t('message.onBoardingTabs.confirmModal.confirmationTitle')"-->
      <!--      hide-footer>-->
      <!--      <p>{{ $t('message.onBoardingTabs.confirmModal.confirmationText') }}</p>-->
      <!--      <div class="col">-->
      <!--        <coozzy-button-->
      <!--          size="small"-->
      <!--          class="border mb-0"-->
      <!--          design="transparent"-->
      <!--          @click="$bvModal.hide('confirmationModal')">-->
      <!--          {{ $t('message.generic.cancel') }}-->
      <!--        </coozzy-button>-->
      <!--        <coozzy-button-->
      <!--          size="small"-->
      <!--          class="float-right mb-0"-->
      <!--          design="green"-->
      <!--          @click="confirmCancellation">-->
      <!--          {{ $t('message.onBoardingTabs.confirmModal.confirmationButton') }}-->
      <!--        </coozzy-button>-->
      <!--      </div>-->
      <!--    </b-modal>-->
    </div>
  </section>
</template>

<script lang="ts">
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner.vue'
import CoozzyFormInput from '@/framework/components/form/input/CoozzyFormInput.vue'
import CoozzyPageTitle from '@/framework/layout/CoozzyPageTitle.vue'
import CoozzyMultiselect from '@/framework/components/multiselect/CoozzyMultiselect.vue'
import { user } from '@/mixins/user'
import { obj } from '@/mixins/object'
import { formatting } from '@/mixins/formatting'
import { tables } from '@/mixins/tables'
import { routeChecks } from '@/mixins/routeChecks'
import {
  ObjecthandoverProtocolCreateTemplateRequest,
  ObjecthandoverProtocolDevice, ObjecthandoverProtocolRoom
} from '@/types/api'
import ObjectApi from '@/misc/apis/ObjectApi'
import Vue from 'vue'
import HandoverRoomsStep from '@/handover/component/HandoverRoomsStep.vue'
import HandoverDevicesStep from '@/handover/component/HandoverDevicesStep.vue'
import RoomApi from '@/misc/apis/RoomApi'
import HandoverProtocolApi from '@/misc/apis/HandoverProtocolApi'
import HandoverKeysStep from '@/handover/component/HandoverKeysStep.vue'
import { required } from 'vuelidate/lib/validators'

export default Vue.extend({
  name: 'HandoverTemplateCreation',
  components: {
    HandoverKeysStep,
    HandoverDevicesStep,
    HandoverRoomsStep,
    CoozzyPageTitle,
    CoozzyFormInput,
    CoozzyMultiselect,
    CoozzySpinner
  },
  mixins: [user, obj, formatting, tables, routeChecks],
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      rooms: [],
      activeTab: 0 as number,
      loading: true as boolean,
      navigateViaButtons: false as boolean,
      globalDeletedDeviceIds: [] as ObjecthandoverProtocolDevice[],
      devicesWithoutRooms: [] as ObjecthandoverProtocolDevice[],
      availablePropertyOptions: [] as Array<any>,
      selectedProperties: [] as Array<any>,
      selectedRooms: [] as ObjecthandoverProtocolRoom[],
      deletedRooms: [] as string[],
      deletedDevices: [] as string[],
      listDevices: [],
      handover: {
        name: '',
        rooms: [],
        devicesWithoutRoomIds: [],
        templateReferences: [],
        ownerId: ''
      } as ObjecthandoverProtocolCreateTemplateRequest
    }
  },
  computed: {
    preSelectedRooms() {
      return this.selectedRooms
    },
    initKeys() {
      return this.devicesWithoutRooms
        .filter(d => ['DEVICE_TYPE_LOCKING_KEY', 'DEVICE_TYPE_LOCKING_WIRELESS_TRANSMITTER'].includes(d.type))
        .map(k => this.listDevices.find(d => d.id === k.id) || k)
        .sort((a, b) => a.order - b.order)
    }
  },
  watch: {
  },
  mounted() {
    const init = async () => {
      this.loading = true
      try {
        if (this.id) {
          const response = await HandoverProtocolApi.handoverListTemplateById(this.id)
          this.handover = response.template
          this.name = this.handover.name
        }
        // Load independent data in parallel, then devices after rooms
        await Promise.all([
          this.getPropertiesOptions(),
          this.loadRooms()
        ])
        await this.loadDevices()
      } catch (e) {
        console.log(e)
        Vue.toasted.show(this.$t('message.loadingErrors.object'), { type: 'error' })
      } finally {
        this.loading = false
      }
    }
    init()
  },
  methods: {
    async loadDevices() {
      const ids = this.handover.devicesWithoutRoomIds.concat((this.handover.rooms.map(r => r.deviceIds).flat()).filter(x => x !== null && x !== undefined))
      if (ids.length > 0) {
        await ObjectApi.listDevicesByIds(ids)
          .then(response => {
            this.listDevices = response.devices
            this.devicesWithoutRooms = this.devicesWithoutRooms.concat(response.devices.filter(d => d.roomId === '' || d.roomId === null))
            this.devicesWithoutRooms = this.devicesWithoutRooms.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)
          })
          .catch(e => {
            console.log(e)
            Vue.toasted.show(this.$t('message.loadingErrors.object'), { type: 'error' })
            throw e
          })
      }
      this.handover.rooms.forEach((room, index) => {
        const existingRoom = this.rooms.find(r => r.id === room.id)
        const devicesOfRoom = this.listDevices.filter(d => d.roomId === room.id)
        if (existingRoom) {
          room.name = existingRoom.name
          room.devices = devicesOfRoom.length > 0 ? devicesOfRoom : (existingRoom.devices || [])
          room.order = existingRoom.order || index + 1
        }
        this.selectedRooms.push(room)
      })
      this.selectedRooms = this.selectedRooms.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)
      return Promise.resolve()
    },
    loadRooms() {
      if (this.handover.rooms.length === 0) {
        return Promise.resolve()
      }
      return RoomApi.getRoomListByIds(this.handover.rooms.map(x => x.id))
        .then(response => {
          this.rooms = this.rooms.concat(response.rooms)
        })
        .catch(e => {
          console.log(e)
          Vue.toasted.show(this.$t('message.loadingErrors.object'), { type: 'error' })
          throw e
        })
    },
    getPropertiesOptions() {
      return ObjectApi.propertyListFilterOptions()
        .then(response => {
          this.availablePropertyOptions = response.options
          this.handover.templateReferences?.forEach((property) => {
            let option = this.availablePropertyOptions.find(p => p.id === property.propertyId)
            if (!option) {
              option = {
                id: property.propertyId,
                name: property.propertyName,
                buildingIds: [],
                ownerId: ''
              }
              this.availablePropertyOptions.push(option)
            }
            this.selectedProperties.push(option)
          })
        })
        .catch(e => {
          console.log(e)
          Vue.toasted.show(this.$t('message.loadingErrors.generic'), { type: 'error' })
          throw e
        })
    },
    customLabelProperty(item) {
      return item?.name ?? ''
    },
    isDeletedDeviceId(id) {
      return !!id && this.deletedDevices.includes(id)
    },
    storeSelectedRooms(rooms, object = null, from) {
      if (rooms.length > 0 && this.activeTab === 0 && from === 'rooms') {
        this.selectedRooms = [
          ...rooms,
          ...this.selectedRooms
        ].filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)
      } else if (rooms.length > 0 && this.activeTab === 1 && from === 'device') {
        rooms.forEach((childRoom) => {
          const roomIndex = this.selectedRooms.findIndex(r => r.id === childRoom.id)
          if (roomIndex !== -1 && childRoom.devices) {
            this.$set(this.selectedRooms[roomIndex], 'devices', childRoom.devices)
          }
        })
      }
    },
    storeDeletedRooms(rooms, object) {
      // delete rooms deleted from selected rooms
      this.deletedRooms = this.deletedRooms.concat(rooms).filter((v, i, a) => a.findIndex(t => (t === v)) === i)
      // list of devices that are have roomId = one of the rooms deleted
      const devices = this.listDevices.filter(x => rooms.map(r => r).includes(x.roomId))
      if (devices.length > 0) {
        this.storeDeletedDevices(devices, object)
      }
    },
    async handleTabChange(prevIndex, nextIndex) {
      // Navigating from rooms to devices or keys should validate and save
      if (prevIndex === 0 && nextIndex > 0) {
        this.$v.$touch()
        if (this.$v.$invalid) {
          // Stay on rooms tab if validation fails
          this.$nextTick(() => {
            this.activeTab = prevIndex
            this.preventChangesInSelectedObjectToProcess = prevIndex !== 0
            if (this.$refs['wizard-form']) {
              this.$refs['wizard-form'].initializeTabs()
            }
          })
          Vue.toasted.show(this.$t('message.savingErrors.mandatoryMissing'), { type: 'error' })
          return
        }
        if (!this.navigateViaButtons) {
          await this.saveStep({ activeTabIndex: prevIndex, isLastStep: false })
        }
      }
      // Devices saved when navigating away from devices tab (Step 2) or keys tab (Step 3)
      if (!this.navigateViaButtons && (prevIndex === 1 || prevIndex === 2)) {
        await this.saveStep({ activeTabIndex: prevIndex, isLastStep: false }, false)
      }
      this.activeTab = nextIndex
      this.preventChangesInSelectedObjectToProcess = nextIndex !== 0
      if (this.navigateViaButtons) {
        this.navigateViaButtons = false
      }
    },
    async backClicked(props) {
      await this.saveStep(props, true)
      this.$nextTick(() => {
        props.prevTab()
        this.scrollToTop()
      })
    },
    async nextStep(props) {
      this.$v.$touch()
      if (this.$v.$invalid) {
        Vue.toasted.show(this.$t('message.savingErrors.mandatoryMissing'), { type: 'error' })
        return
      }
      this.navigateViaButtons = true
      await this.saveStep(props)
      this.$nextTick(() => {
        props.nextTab()
        this.scrollToTop()
      })
    },
    async saveStep(props, back = false) {
      if (props.activeTabIndex === 0) {
        if (this.selectedRooms.length > 0) {
          this.selectedRooms = this.selectedRooms.filter(r => !this.deletedRooms.map(r => r).some(r2 => r2 === r.id))
          const roomToUpdate = this.selectedRooms.filter(room => room.edited)
          let roomToDelete = this.deletedRooms || []
          if (roomToDelete && roomToDelete.length > 0) {
            roomToDelete = roomToDelete.map(r => r)
            // remove the rooms that are not started with room_
            roomToDelete = roomToDelete.filter(r => typeof r === 'string' && r.startsWith('room_'))
          }
          let deviceToDelete = (this.deletedDevices || []).filter(id => typeof id === 'string' && id.startsWith('device_'))
          const roomToAdd = (this.selectedRooms.filter(r => !this.deletedRooms.map(r => r).some(r2 => r2 === r.id)))?.filter(room => typeof room.id !== 'string' || !room?.id?.startsWith('room_'))
          const promises = []
          if (roomToUpdate.length > 0) {
            promises.push(RoomApi.updateRooms(roomToUpdate))
          }
          if (roomToAdd.length > 0) {
            promises.push(RoomApi.createRooms(roomToAdd))
          }
          if (roomToDelete.length > 0) {
            promises.push(RoomApi.deleteRooms(roomToDelete))
          }
          if (deviceToDelete.length > 0) {
            deviceToDelete.forEach((device) => {
              promises.push(ObjectApi.deleteDevice(device))
            })
          }
          await Promise.all(promises)
            .then(responses => {
              if (deviceToDelete.length > 0) {
                Vue.toasted.show(this.$t('message.successMessages.deviceDeleted'), { type: 'success' })
              }
              const deletedRoomsIds = this.deletedRooms?.map(r => r) || []
              // take order of rooms from rooms that have temp id and internalId and update them on the response of added rooms
              this.rooms.forEach((room) => {
                if (room.id.startsWith('temp') || room.internalId) {
                  // check by name if the room exists in responses
                  const responseRoom = responses.find(r => r.rooms?.some(resRoom => resRoom.name === room.name))
                  if (responseRoom && responseRoom.rooms) {
                    const updatedRoom = responseRoom.rooms.find(resRoom => resRoom.name === room.name)
                    if (updatedRoom) {
                      updatedRoom.order = room.order
                    }
                  }
                }
              })
              this.rooms = this.rooms.filter(d => !d.id.startsWith('temp') && !d.internalId && !deletedRoomsIds.some(r => r === d.id))
              if (responses.length > 0) {
                // update every room from selectedRoom with the new from response,
              // but preserve existing devices since the API response does not include them
                this.selectedRooms.forEach((room, indexRoom) => {
                  if (room.edited) {
                    const updatedRoom = responses[0].rooms?.find(r => r.id === room.id) || responses[1]?.rooms?.find(r => r.id === room.id)
                    if (updatedRoom) {
                      this.selectedRooms[indexRoom] = { ...updatedRoom, devices: room.devices }
                    }
                  }
                })
                this.selectedRooms = this.selectedRooms.filter(r => typeof r.id === 'string' && r.id.startsWith('room_'))
                responses.forEach((response) => {
                  if (response?.rooms) {
                    this.selectedRooms = this.selectedRooms.concat(response.rooms)
                    this.rooms = this.rooms.concat(response.rooms)
                  }
                })
                // remove delete rooms from selectedrooms
                this.selectedRooms = this.selectedRooms.filter(r => !roomToDelete.includes(r.id))
              }
              const deletedDeviceIds = [...this.deletedDevices]
              this.listDevices = this.listDevices.filter(d =>
                !deletedDeviceIds.includes(d.id) && !deletedRoomsIds.some(r => r === d.roomId)
              )
              this.$nextTick(() => {
                this.deletedRooms = []
                this.deletedDevices = []
              })
            }).catch(e => {
              console.log(e)
              Vue.toasted.show(this.$t('message.savingErrors.onboarding'), { type: 'error' })
            })
            .finally(() => {
              this.$nextTick(() => {
                // sort rooms by order
                this.selectedRooms = this.selectedRooms.sort((a, b) => a.order - b.order)
                if (this.id) {
                  this.saveHandoverProcessTemplate(props.isLastStep)
                }
              })
            })
        }
      } else if (props.activeTabIndex === 1) {
        // create the new devices and update the edited devices
        let devicesToAdd = []
        const devicesToUpdate = []
        let deviceToDelete = this.deletedDevices || []
        if (deviceToDelete?.length > 0) {
          deviceToDelete = deviceToDelete.map(r => r)
          deviceToDelete = deviceToDelete.filter(r => typeof r === 'string' && r.startsWith('device_'))
          // remove the device from the list if it exists on globalDeletedDeviceIds
          deviceToDelete = deviceToDelete.filter(d => !this.globalDeletedDeviceIds.some(r => r === d))
        }
        for (let index = 0; index < this.selectedRooms.length; index++) {
          if (this.selectedRooms[index].devices) {
            this.selectedRooms[index].devices.forEach((device) => {
              const originalDevice = this.listDevices.find(d => d.id === device.id)
              const roomIdChanged = originalDevice && originalDevice.roomId !== this.selectedRooms[index].id
              device.roomId = this.selectedRooms[index].id
              if (device.internalId || !device.id.startsWith('device_')) {
                devicesToAdd.push(JSON.parse(JSON.stringify(device)))
              } else if ((device.edited || roomIdChanged) && device.id) {
                devicesToUpdate.push(JSON.parse(JSON.stringify(device)))
              }
            })
          }
        }
        for (let index = 0; index < this.devicesWithoutRooms.filter(x => x.referenceId === 'template').length; index++) {
          if (this.devicesWithoutRooms.filter(x => x.referenceId === 'template')[index].internalId || !this.devicesWithoutRooms.filter(x => x.referenceId === 'template')[index].id.startsWith('device_')) {
            devicesToAdd.push(this.devicesWithoutRooms.filter(x => x.referenceId === 'template')[index])
          } else if (this.devicesWithoutRooms.filter(x => x.referenceId === 'template')[index].edited) {
            devicesToUpdate.push(this.devicesWithoutRooms.filter(x => x.referenceId === 'template')[index])
          }
        }
        const promises = []
        // remove duplicated devices in devicesToAdd
        devicesToAdd = devicesToAdd.filter((v, i, a) => a.findIndex(t => (t.internalId === v.internalId)) === i)
        if (devicesToAdd.length > 0) {
          devicesToAdd.forEach((device) => {
            promises.push(ObjectApi.createDevice(device))
          })
        }
        if (devicesToUpdate.length > 0) {
          devicesToUpdate.forEach((device) => {
            promises.push(ObjectApi.updateDevice(device))
          })
        }
        if (deviceToDelete.length > 0) {
          deviceToDelete.forEach((device) => {
            promises.push(ObjectApi.deleteDevice(device))
          })
        }
        if (promises.length === 0) {
          if (this.id) {
            this.saveHandoverProcessTemplate(props.isLastStep)
          }
          return
        }
        await Promise.all(promises)
          .then(responses => {
            if (deviceToDelete.length > 0) {
              Vue.toasted.show(this.$t('message.successMessages.deviceDeleted'), { type: 'success' })
            }
            const deletedDevicesIds = this.deletedDevices || []
            this.listDevices = this.listDevices.filter(d => !d.internalId && !deletedDevicesIds.some(r => r === d.id))
            if (responses.length > 0) {
              const unassignedDevices = []
              responses.map(item => item.device).forEach((device) => {
                if (device) {
                  this.listDevices = this.listDevices.filter(d => d.id !== device.id)
                  this.listDevices.push(device)
                  if (device?.roomId === '') {
                    unassignedDevices.push(device)
                  }
                }
              })
              if (unassignedDevices.length > 0) {
                // remove the devices that are not started with device_
                this.devicesWithoutRooms = this.devicesWithoutRooms.filter(x => !x.internalId)
                // this.devicesWithoutRooms = JSON.parse(JSON.stringify(this.devicesWithoutRooms.filter(x => !x.internalId)))
                unassignedDevices.forEach((device) => {
                  if (!device.internalId && !this.devicesWithoutRooms.find(x => x.id === device.id)) {
                    this.devicesWithoutRooms.push(device)
                  } else if (!device.internalId) {
                    const index = this.devicesWithoutRooms.findIndex(x => x.id === device.id)
                    if (index !== -1) {
                      this.$set(this.devicesWithoutRooms, index, device)
                    }
                  }
                })
              }

              for (let index = 0; index < this.selectedRooms.length; index++) {
                if (this.selectedRooms[index].devices) {
                  // remove the device with internalId
                  this.selectedRooms[index].devices = this.selectedRooms[index].devices.filter(d => !d.internalId)
                  // add the new devices for the room by roomId
                  responses.map(item => item.device).forEach((device) => {
                    if (device?.roomId === this.selectedRooms[index].id) {
                      device.value = device.type === '' || device.type === null || device.type === 'DEVICE_TYPE_UNDEFINED' ? '-' : this.$t('message.onBoarding.devices.typeValues.' + device.type)
                      const deviceIndex = this.selectedRooms[index].devices.findIndex(d => d.id === device.id)
                      if (deviceIndex !== -1) {
                        this.$set(this.selectedRooms[index].devices, deviceIndex, device)
                      } else {
                        this.selectedRooms[index].devices.push(device)
                      }
                    }
                  })
                  // this.selectedRoomss[index].devices = this.selectedRooms[index].devices.concat(responses.map(item => item.device).filter(r => r.roomId === this.selectedRooms[index].id))
                }
              }
              this.$nextTick(() => {
                this.deletedDevices = []
              })
            } else {
              this.$nextTick(() => {
                this.deletedDevices = []
              })
            }
          }).catch(e => {
            console.log(e)
            Vue.toasted.show(this.$t('message.savingErrors.onboarding'), { type: 'error' })
          })
          .finally(() => {
            // set the newest value of selectedRooms
            this.selectedRooms = JSON.parse(JSON.stringify(this.selectedRooms))
            this.devicesWithoutRooms = this.devicesWithoutRooms
              .filter(x => x.id?.startsWith('device_') && !x.internalId)
              .map(device => ({
                ...device,
                edited: device.edited || false
              }))
            if (this.id) {
                this.saveHandoverProcessTemplate(props.isLastStep)
              }
          })
      } else if (props.activeTabIndex === 2) {
        // create the new devices and update the edited devices
        this.devicesWithoutRooms = this.devicesWithoutRooms.slice().sort((a, b) => a.order - b.order)
        const devicesToAdd = []
        const devicesToUpdate = []
        let deviceToDelete = this.deletedDevices || []
        if (deviceToDelete?.length > 0) {
          deviceToDelete = deviceToDelete.filter(r => typeof r === 'string' && r.startsWith('device_'))
          // remove the device from the list if it exists on globalDeletedDeviceIds
          deviceToDelete = deviceToDelete.filter(d => !this.globalDeletedDeviceIds.some(r => r === d))
        }
        for (let index = 0; index < this.devicesWithoutRooms.length; index++) {
          const device = this.devicesWithoutRooms[index]
          const newOrder = index + 1
          const orderChanged = device.order !== newOrder
          device.order = newOrder

          if (!device.id.startsWith('device_')) {
            devicesToAdd.push(device)
          } else if (device.edited || orderChanged) {
            devicesToUpdate.push(device)
          }
        }
        const promises = []
        if (devicesToAdd.length > 0) {
          devicesToAdd.forEach((device) => {
            promises.push(ObjectApi.createDevice(device))
          })
        }
        if (devicesToUpdate.length > 0) {
          devicesToUpdate.forEach((device) => {
            promises.push(ObjectApi.updateDevice(device))
          })
        }
        if (deviceToDelete.length > 0) {
          deviceToDelete.forEach((device) => {
            promises.push(ObjectApi.deleteDevice(device))
          })
        }
        if (promises.length === 0) {
          if (props.isLastStep && !back) {
            this.saveHandoverProcessTemplate(props.isLastStep)
          }
        }
        await Promise.all(promises)
          .then(responses => {
            if (responses.length > 0) {
              if (deviceToDelete.length > 0) {
                Vue.toasted.show(this.$t('message.successMessages.deviceDeleted'), { type: 'success' })
              }
              const deleteddeviceIds = this.deletedDevices || []
              this.globalDeletedDeviceIds = this.globalDeletedDeviceIds.concat(deviceToDelete)
              this.listDevices = this.listDevices.filter(d => !d.internalId && !deleteddeviceIds.some(r => r === d.id))
              if (responses.length > 0) {
                const unassignedDevices = []
                responses.map(item => item.device).forEach((device) => {
                  if (device) {
                    this.listDevices = this.listDevices.filter(d => d.id !== device.id)
                    this.listDevices.push(device)
                    if (device?.roomId === '') {
                      unassignedDevices.push(device)
                    }
                  }
                })
                if (unassignedDevices.length > 0) {
                  this.devicesWithoutRooms = this.devicesWithoutRooms
                    .filter(x => !x.internalId)
                    .map(device => ({
                      ...device,
                      edited: device.edited || false
                    }))
                  unassignedDevices.forEach((device) => {
                    if (!this.devicesWithoutRooms.find(x => x.id === device.id)) {
                      this.devicesWithoutRooms.push(device)
                    } else {
                      const index = this.devicesWithoutRooms.findIndex(x => x.id === device.id)
                      if (index !== -1) {
                        this.$set(this.devicesWithoutRooms, index, device)
                      }
                    }
                  })
                }
              }
              this.$nextTick(() => {
                // remove the devices that are not started with device_
                this.devicesWithoutRooms = this.devicesWithoutRooms
                  .filter(x => x.id.startsWith('device_') && !x.internalId)
                  .map(device => ({
                    ...device,
                    edited: device.edited || false
                  }))
              })
            }
          })
          .catch(e => {
            console.log(e)
            Vue.toasted.show(this.$t('message.savingErrors.onboarding'), { type: 'error' })
          })
          .finally(() => {
            if (promises.length !== 0 && props.isLastStep && !back) {
              this.saveHandoverProcessTemplate(props.isLastStep)
            }
          })
      }
    },
    saveHandoverProcessTemplate(isLastStep) {
      this.isSaving = true
      this.handover.templateReferences = []
      this.handover.rooms = []
      this.selectedProperties
        .filter(object => object?.id)
        .forEach((object) => {
          this.handover.templateReferences.push({
            propertyId: object.id,
            propertyName: object.name
          })
        })
      this.handover.ownerId = this.$store.getters['user/getAccountId']
      // remove duplicated room
      this.selectedRooms = this.selectedRooms.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)
      // remove rooms that are not started with room_ or in deletedRooms
      this.selectedRooms = this.selectedRooms.filter(room => typeof room.id === 'string' && room.id.startsWith('room_') && !this.deletedRooms.map(r => r).some(r2 => r2 === room.id))
      // sort rooms by order
      this.selectedRooms = this.selectedRooms.sort((a, b) => a.order - b.order)
      this.selectedRooms.forEach((room) => {
        if (!this.deletedRooms.includes(room.id)) {
          this.handover.rooms.push({
            id: room.id,
            deviceIds: room?.devices?.filter(device => !this.isDeletedDeviceId(device.id))?.map(device => device.id)
          })
        }
      })
      this.handover.devicesWithoutRoomIds = this.devicesWithoutRooms.map(device => device.id)
      const promises = []
      if (this.id) {
        promises.push(HandoverProtocolApi.handoverUpdateTemplate(this.id, this.handover))
      } else {
        promises.push(HandoverProtocolApi.createTemplate(this.handover))
      }
      if (promises.length > 0) {
        Promise.all(promises).then(() => {
          if (isLastStep) {
            Vue.toasted.show(this.$t('message.successMessages.handoverProtocolTemplate'), { type: 'success' })
            const nameRoute = this.isOwnerModule ? 'OwnerSettingsView' : this.isAdminModule ? 'AdminSettingsView' : this.isAssetModule ? 'AssetSettingsView' : this.isAccountingModule ? 'AccountingSettingsView' : 'MarketingSettingsView'
            this.$router.push({ name: nameRoute, query: { view: 4 } })
            this.isSaving = false
          }
        })
          .catch(e => {
            this.isSaving = false
            console.log(e)
            Vue.toasted.show(this.$t('message.savingErrors.onboarding'), { type: 'error' })
          })
      } else {
        this.isSaving = false
      }
    },
    storeDeletedDevices(devices) {
      const ids = devices
        .map(d => (typeof d === 'string' ? d : d?.id))
        .filter(id => !!id)
      this.deletedDevices = this.deletedDevices.concat(ids).filter((v, i, a) => a.findIndex(t => (t === v)) === i)
    },
    storeDevicesWithoutRooms(devices, object, from, deleteDevice = '') {
      if ((from === 'device' && this.activeTab === 2) || (this.activeTab === 1 && from === 'keys')) {
        return
      }
     this.devicesWithoutRooms = [
        ...this.devicesWithoutRooms,
        ...devices
      ].filter(device =>
        !this.isDeletedDeviceId(device.id) &&
        !this.globalDeletedDeviceIds.includes(device.id) &&
        (!device.roomId || device.roomId === '') && ((device.id === '' || device.id !== deleteDevice) && device.referenceId === 'template')
      ).reduce((unique, device) => {
        const index = unique.findIndex(d => (d.id !== '' && device.id !== '' && d.id === device.id) || (d.internalId && device.internalId && d.internalId === device.internalId))
        if (index !== -1) {
          unique[index] = { ...unique[index], ...device, edited: device.edited || unique[index].edited }
          return unique
        }
        return [...unique, device]
      }, [])
    },
    scrollToTop() {
      this.$nextTick(() => {
        const domRect = this.$el.querySelector('#wizard')
        if (!domRect) {
          return
        }
        domRect.scrollIntoView(true)
      })
    }
  },
  validations() {
    return {
      handover: {
        name: {
          required
        }
      }
    }
  }
})
</script>
<style scoped lang="scss">

</style>
